import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        gridWrapper: {
            display: 'grid',
            gridGap: theme.spacing(2),
            gridTemplateColumns: '1fr',
        },
        createLocationLink: {
            paddingTop: theme.spacing(2),
            marginBottom: `-${theme.spacing(1)}`,
        },
    }
})

export default useStyles
